import React from "react";
import { Box, IconButton, InputBase, Tooltip, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import RefreshIcon from "@mui/icons-material/Refresh";

function CustomPlaylistCallsToolbar({
  searchQuery,
  onSearch,
  onFilterClick,
  onColumnClick,
  onRefresh,
  isSmallScreen,
}) {
  const theme = useTheme();

  const iconButtonStyle = {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    padding: "4px",
    height: "30px",
    width: "30px",
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.text.secondary,
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isSmallScreen ? "column" : "row",
        alignItems: isSmallScreen ? "stretch" : "center",
        gap: 1,
        width: isSmallScreen ? "100%" : "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.background.buttonGrey,
          borderRadius: 1,
          px: 1.5,
          py: 0.5,
          minWidth: isSmallScreen ? "100%" : 250,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <SearchIcon sx={{ fontSize: 20, mr: 1 }} />
        <InputBase
          placeholder="Search playlists..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          sx={{ flex: 1, fontSize: "0.875rem" }}
        />
      </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="Filter list">
          <IconButton size="small" onClick={onFilterClick} sx={iconButtonStyle}>
            <FilterListIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Choose columns">
          <IconButton size="small" onClick={onColumnClick} sx={iconButtonStyle}>
            <ViewColumnIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Refresh">
          <IconButton size="small" onClick={onRefresh} sx={iconButtonStyle}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

export default CustomPlaylistCallsToolbar;
